import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Pagination from './../../../../../components/common/pagination/index';
import { actionTypes } from './../../../../../redux/news/getAllNews/getAllNews';
import { useDispatch, useSelector } from "react-redux";
import { Grid, Chip } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab"; // 🆕 اضافه شد


const useStyles = makeStyles((theme) => ({
    root: {
        ...theme.grid.gridMdContent,
        margin: '70px auto',
        maxWidth: '100%'
    },
    gridLoading: {
        ...theme.grid.gridMdContent,
        display: 'flex',
        justifyContent: 'center',
        marginTop: 20
    },
    card: {
        width: '100%',
        display: 'flex',
        minHeight: 100,
        backgroundColor: '#fff',
        boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
        borderRadius: 10,
        padding: 16,
        marginBottom: 16,
        cursor: 'pointer',
        transition: 'all 0.3s ease, transform 0.5s ease', // ترنزیشن روی حالت هاور
        opacity: 0,
        transform: 'scale(0.95) translateY(20px)', // شروع کمی کوچیک‌تر و پایین‌تر
        animation: `$popIn 1s ease forwards`, // انیمیشن جدید
        animationDelay: '0.2s', // برای خفن‌تر شدن، یه تاخیر کم
        '&:hover': {
            boxShadow: '0px 6px 20px rgba(0, 0, 0, 0.15)',
            transform: 'scale(1.02)', // حالت هاور، یه ذره بزرگتر میشه
        },
        '@media (max-width:550px)': {
            width: '100%',
            flexDirection: 'column',
        },
    },

    gridImages: {
        '@media (max-width:550px)': {
            width: '100%',
            display: 'flex',
            justifyContent: 'center'
        },
    },
    images: {
        width: 150,
        height: 100, // ارتفاع فیکس مثل اسکلتون
        objectFit: 'cover', // عکس قشنگ کشیده نشه
        borderRadius: 8, // گرد شدن عکس
    },
    title: {
        fontWeight: 'bold',
        marginTop: 10,
        fontSize: 18, // کمی بزرگتر برای خوانایی بهتر
        color: '#333', // رنگ تیره‌تر
    },
    date: {
        color: 'rgba(0,0,0,0.5)',
        marginBottom: 0,
        marginLeft: 10,
        fontSize: 14
    },
    desc: {
        textOverflow: "ellipsis",
        display: "-webkit-box",
        overflow: "hidden",
        WebkitLineClamp: 3, // فقط سه خط نشون بده
        WebkitBoxOrient: "vertical",
        whiteSpace: "break-spaces",
        color: 'rgba(0,0,0,0.6)', // متن خلاصه رنگ خاکستری‌تر
        marginBottom: 0,
        fontSize: 14, // کمی کوچک‌تر
    },
    content: {
        marginLeft: 16,
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
    gridTags: {
        marginTop: 10
    },
    '@keyframes popIn': {
        '0%': {
            opacity: 0,
            transform: 'scale(0.95) translateY(20px)',
        },
        '60%': {
            opacity: 1,
            transform: 'scale(1.02) translateY(-4px)', // یه کوچولو میره بالا و بزرگ میشه
        },
        '100%': {
            opacity: 1,
            transform: 'scale(1) translateY(0)', // بعد صاف میشه
        },
    },
}));

export default function Index({ stateNews, setStateNews, tags, setTags }) {

    const classes = useStyles();
    let dispatch = useDispatch();

    let reducerData = useSelector(state => state?.get_all_news_reducer);


    let [flagApi, setFlagApi] = useState(false);

    const [pagnation, setPagnation] = useState({
        number: 0,
        count: 0
    });

    useEffect(() => {
        let payload = {
            pageNumber: pagnation.number,
            data: {},
        }
        dispatch(({ type: actionTypes?.getAllNewsAsync, payload: payload }))
    }, [flagApi]);


    useEffect(() => {
        if (reducerData?.data?.length) { 
            setStateNews(reducerData?.data)
            setPagnation((prev) => ({
                ...prev,
                count: Math.ceil(reducerData.total / reducerData.size),
            }));
        }
    }, [reducerData]);


    const base64File = (data) => {
        if (!data) {
            return;
        }
        let filetype = data.slice(0, 4);
        if (filetype === "/9j/") {
            return `data:image/jpeg;base64,${data}`
        } else {
            return `data:image/png;base64,${data}`
        }
    };


    const handelPagnation = (value) => {
        setPagnation((prev) => ({ ...prev, number: value }))
        setFlagApi(prev => !prev)
    };

    const handelRoute = (event, value) => {
        let link = value?.contentLinkUrl
        window.open(link, '_blank');
    };

    const handelClickTags = (event, tag) => {
        event.stopPropagation();
        setTags(tag)
        setFlagApi(prev => !prev)
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };


    return (
        <>

            {
                reducerData?.loading ? (
                    <>
                        {[...Array(3)].map((_, index) => (
                            <div key={index} className={classes['card']}>
                                <div className={classes['gridImages']}>
                                    <Skeleton variant="rect" width={150} height={100} style={{ borderRadius: 5 }} animation="wave" />
                                </div>
                                <div className={classes['content']} style={{ flex: 1 }}>
                                    <Skeleton variant="text" width="80%" height={30} style={{ marginTop: 10 }} animation="wave" />
                                    <Skeleton variant="text" width="60%" height={20} animation="wave" />
                                    <Skeleton variant="text" width="90%" height={20} animation="wave" />
                                    <Skeleton variant="text" width="70%" height={20} animation="wave" />
                                </div>
                            </div>
                        ))}
                    </>
                ) : (
                    stateNews?.map((item, index) => {
                        let { title, summary, imageData, createDateTime, tagsList } = item
                        return (
                            <div className={classes['card']} key={index} onClick={(e) => handelRoute(e, item)}>
                                <div className={classes['gridImages']}>
                                    <img src={base64File(imageData)} alt={title} className={classes['images']} />
                                </div>
                                <div className={classes['content']}>
                                    <h6 className={classes['title']}>
                                        {title}
                                        <span className={classes['date']}>
                                            ({createDateTime?.replaceAll('-', '/')})
                                        </span>
                                    </h6>
                                    <p className={classes['desc']}>
                                        {summary}
                                    </p>
                                    <Grid container spacing={1} className={classes['gridTags']}>
                                        {tagsList?.map((tag, index) => (
                                            <Grid item key={index}>
                                                <Chip
                                                    label={`#${tag?.name}`}
                                                    variant="outlined"
                                                    color="primary"
                                                    onClick={(event) => handelClickTags(event, tag)}
                                                />
                                            </Grid>
                                        ))}
                                    </Grid>
                                </div>
                            </div>
                        )
                    })
                )
            }
            {
                (stateNews?.length === 0 && !reducerData?.loading) && (
                    <div className={classes['gridLoading']}>
                        <p>
                            دیتای یافت نشد
                        </p>
                    </div>
                )
            }

            <div>
                {
                    (pagnation.count >= 2 && !reducerData?.loading) && (
                        <Pagination
                            className={classes['pagination']}
                            count={pagnation.count}
                            pagnation={pagnation.number}
                            setPagnation={(_data) => handelPagnation(_data)}
                        />
                    )
                }
            </div>


        </>
    );
}
